package app.api

import app.client
import app.model.PaginatedResponse
import app.model.RolloutExecution
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import kotlinx.coroutines.Job

class RolloutExecutionsPaginatedApi : RootStore<PaginatedResponse<RolloutExecution>>(
    PaginatedResponse(emptyList(), 0, 0, 0, 10),
    job = Job()
) {
    data class PaginationRequest(
        val projectId: String,
        val sort: String,
        val order: String,
        val page: Int,
        val pageSize: Int = 10
    )

    val handler = handle { _, req: PaginationRequest ->
        val projectId = req.projectId.toInt()
        client.get(
            Routing.RolloutExecutions.Sort(
                projectId = projectId,
                sort = req.sort,
                order = req.order,
                page = req.page,
                size = req.pageSize,
            )
        ).body<PaginatedResponse<RolloutExecution>>()
    }
}
